import { render, staticRenderFns } from "./ErpEmptyModal.vue?vue&type=template&id=6f0f849c&scoped=true&"
import script from "./ErpEmptyModal.vue?vue&type=script&lang=js&"
export * from "./ErpEmptyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f849c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0f849c')) {
      api.createRecord('6f0f849c', component.options)
    } else {
      api.reload('6f0f849c', component.options)
    }
    module.hot.accept("./ErpEmptyModal.vue?vue&type=template&id=6f0f849c&scoped=true&", function () {
      api.rerender('6f0f849c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tips/ErpEmptyModal.vue"
export default component.exports